import { Loader } from '@googlemaps/js-api-loader'

export default {
  name: 'map',

  lat: null,
  lng: null,

  componentDidMount () {
    const loader = new Loader({
      apiKey: process.env.GOOGLEMAP_API_KEY,
      version: 'weekly',
    })

    loader.load().then(() => {
      this.geocoder = new google.maps.Geocoder()
      this.geocoder.geocode(
        { address: this.props.address },
        (results, status) => {
          if (status === 'OK') {
            this.lat = results[0].geometry.location.lat()
            this.lng = results[0].geometry.location.lng()

            this.map = new google.maps.Map(this.el, {
              center: {
                lat: this.lat,
                lng: parseFloat(parseFloat(this.lng).toFixed(2)) + 0.01,
              }, // slightly move map to left
              zoom: 14,
              disableDefaultUI: true,
              draggable: false,
              zoomControl: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              styles: [
                {
                  featureType: 'administrative',
                  elementType: 'labels.text.fill',
                  stylers: [{ color: '#444444' }],
                },
                {
                  featureType: 'administrative.province',
                  elementType: 'labels.text.fill',
                  stylers: [{ color: '#706f6f' }],
                },
                {
                  featureType: 'administrative.locality',
                  elementType: 'labels.text.fill',
                  stylers: [{ color: '#706f6f' }],
                },
                {
                  featureType: 'administrative.neighborhood',
                  elementType: 'labels.text.fill',
                  stylers: [{ color: '#706f6f' }],
                },
                {
                  featureType: 'landscape',
                  elementType: 'all',
                  stylers: [{ color: '#f2f2f2' }],
                },
                {
                  featureType: 'poi',
                  elementType: 'all',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'road',
                  elementType: 'all',
                  stylers: [{ saturation: -100 }, { lightness: 45 }],
                },
                {
                  featureType: 'road.highway',
                  elementType: 'all',
                  stylers: [{ visibility: 'simplified' }],
                },
                {
                  featureType: 'road.arterial',
                  elementType: 'labels.icon',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'transit',
                  elementType: 'all',
                  stylers: [{ visibility: 'off' }],
                },
                {
                  featureType: 'water',
                  elementType: 'all',
                  stylers: [{ color: '#04B6D5' }, { visibility: 'on' }],
                },
              ],
            })

            const image = {
              url: '/assets/front/img/marker.png',
              size: new google.maps.Size(27, 32),
              // The origin for this image is (0, 0).
              origin: new google.maps.Point(0, 0),
              // The anchor for this image is the base of the flagpole at (0, 32).
              anchor: new google.maps.Point(13, 32),
            }

            /* eslint-disable-next-line */
            new google.maps.Marker({
              position: { lat: this.lat, lng: this.lng },
              icon: image,
              map: this.map,
            })
          } else {
            console.log(
              'Geocode was not successful for the following reason: ' + status,
            )
          }
        },
      )
    })
  },
}
